import { Injectable, inject } from '@angular/core';
import { cloneFilterState } from './data-filter.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { applyFilterDateRange, buildFilterDateRange, toStartEndFilterDateRange } from '../shared/date-filter.util';
@Injectable({
  providedIn: 'root'
})
export class VarianceService {
  private http = inject(HttpClient);

  // Could eventually become changeable in the tables
  readonly DEFAULT_PAGE_SIZE = 20;

  submitDescripencyStatus(id: any, comment: any, userAction: any, resolutionCoding: any, key: any, transType: any, practiceIssue: any, taggedUsers: any, lanId: any, adminGroup: any, employeeName: any, location: any, patientId: any, date: any, medDesc: any, sender: any)
  {
    return this.http.post(environment.apiUrl+'discrepancy_status',{
      "comment":comment,
      "status":resolutionCoding,
      "discrepancy":id, 
      "key":key,'transType':transType, 
      'practiceIssue':practiceIssue, 
      'userAction':userAction, 
      'taggedUsers':taggedUsers,
      'lanId':lanId,
      'adminGroup':adminGroup,
      'employeeName':employeeName,
      'location':location,
      'patientId':patientId,
      'date':date,
      'medDesc':medDesc,
      'sender':sender});
  }

  getResCoding(rowid: any){
    return this.http.get(environment.apiUrl+'discrepancy_status?discrepancy='+rowid);
  }

  getUrcComments(rowid: any, adminId: any, maapKey: any, recordid: any){
    return this.http.get(environment.apiUrl+'discrepancy_status?key='+rowid+'&adminId='+adminId+'&maapKey='+maapKey+'&id='+recordid + '&discrepancy='+recordid);
  }

  getDiscrepancyData()
  {
   return this.http.get(environment.apiUrl+'discrepancies')
  }

  getActivityLinkedRecords(recordId: any){
    const url =  environment.apiUrl +"fetch/linked/records?linkedRecordId="+recordId
    return this.http.get(
      url
     );
  }

  getActivityDiscrepancyData(skip: any, rowData: any, limit: number = this.DEFAULT_PAGE_SIZE)
  {
       const employeeName = this.sanitizeFilterValue(rowData["employeeName"]);

       let employeeId = '';
      if(rowData['adminId'])
        employeeId = this.sanitizeFilterValue(rowData["adminId"]);
      else if (rowData['lanId'])
        employeeId = this.sanitizeFilterValue(rowData["lanId"]);
      else
        employeeId = this.sanitizeFilterValue(rowData["employeeId"]);

       const bedev = this.sanitizeFilterValue(rowData["bedDev"]);
       const facilityId = rowData["facilityId"];

       const serviceGroup = this.sanitizeFilterValue(rowData["serviceGroup"])
       const dateRange = buildFilterDateRange(rowData["transactionStartDate"], rowData["transactionEndDate"]);
       const transactionStartDate = dateRange ? dateRange.startIso : this.sanitizeFilterValue(rowData["transactionStartDate"]);
       const transactionEndDate = dateRange ? dateRange.endExclusiveIso : this.sanitizeFilterValue(rowData["transactionEndDate"]);
       const transType = this.sanitizeFilterValue(rowData['transType']);
       const patientName = this.sanitizeFilterValue(rowData["patientName"]);
       const mrnNum = this.sanitizeFilterValue(rowData["mrnNum"]);
       const medDesc = this.sanitizeFilterValue(rowData["medDesc"]);
       const medGroup = this.sanitizeFilterValue(rowData['medGroup'])
       const csn = this.sanitizeFilterValue(rowData['csn'])
       const ia = this.sanitizeFilterValue(rowData['ia'])
       const regionId = rowData['regionId']
       const campusId = rowData['campusId']
       const sortOrder = this.sanitizeFilterValue(rowData['$sortOrder'])
       const sortfield = this.sanitizeFilterValue(rowData['$sortField'])
       const getGraph = this.sanitizeFilterValue(rowData['getGraph'])
       const resolution = this.sanitizeFilterValue(rowData["resolution"]);
       const practiceIssue = this.sanitizeFilterValue(rowData['practiceIssue'])
       this.tryClearWhitespaceFromGlobalSearch(rowData);
       const globalSearchString = this.sanitizeFilterValue(rowData["globalSearch"]);
       const showMultiAdmins = this.sanitizeFilterValue(rowData["showMultiAdmins"] || false);
       let params = new HttpParams()
        .set('employeeName', this.toHttpParamValue(employeeName))
        .set('employeeId', this.toHttpParamValue(employeeId))
        .set('bedDev', this.toHttpParamValue(bedev))
        .set('transactionStartDate', this.toHttpParamValue(transactionStartDate))
        .set('transactionEndDate', this.toHttpParamValue(transactionEndDate))
        .set('transType', this.toHttpParamValue(transType))
        .set('patientName', this.toHttpParamValue(patientName))
        .set('mrnNum', this.toHttpParamValue(mrnNum))
        .set('medDesc', this.toHttpParamValue(medDesc))
        .set('resolution', this.toHttpParamValue(resolution))
        .set('practiceIssue', this.toHttpParamValue(practiceIssue))
        .set('showMultiAdmins', this.toHttpParamValue(showMultiAdmins))
        .set('medGroup', this.toHttpParamValue(medGroup))
        .set('serviceGroup', this.toHttpParamValue(serviceGroup))
        .set('csn', this.toHttpParamValue(csn))
        .set('$skip', this.toHttpParamValue(skip))
        .set('$limit', this.toHttpParamValue(limit))
        .set('$sortField', this.toHttpParamValue(sortfield))
        .set('$sortOrder', this.toHttpParamValue(sortOrder))
        .set('ia', this.toHttpParamValue(ia))
        .set('getGraph', this.toHttpParamValue(getGraph));
      if (globalSearchString)
      {
        params = params.set('globalSearch', this.toHttpParamValue(globalSearchString));
      }

      // 'tvs' is the Risk Level "All" sentinel and must never be sent as an active risk filter.
      const activeRiskLevels = (Array.isArray(rowData.riskLevel) ? rowData.riskLevel : [rowData.riskLevel])
        .filter((level: any) => level && level !== 'tvs');
      if (activeRiskLevels.length){
        params = params.set('riskLevel', this.toHttpParamValue(activeRiskLevels));
      }

      if(regionId && !regionId.includes("All") && regionId[0]){
        params = params.set('regionId', this.toHttpParamValue(regionId));
      }

      if (campusId && !campusId.includes("All") && campusId[0]){
        params = params.set('campusId', this.toHttpParamValue(campusId));
      }

      if (facilityId && !facilityId.includes("All") && facilityId[0]){
        params = params.set('facilityId', this.toHttpParamValue(facilityId));
      }

      if(rowData["parent"]==true || rowData["subParent"]== true)
      {
        params = params.append('locationGrouping', this.toHttpParamValue(rowData["locationGroupingString"]));
      }
      if(rowData['pageType']){
        params = params.set('pageType', this.toHttpParamValue(rowData['pageType']));
      }
      if(rowData['duration']){
        params = params.set('duration', this.toHttpParamValue(rowData['duration']));
      }
      if(rowData['adminType']){
        params = params.set('adminType', this.toHttpParamValue(rowData['adminType']));
      }
      if(rowData['locationGrouping']){
        params = params.append('locationGrouping', this.toHttpParamValue(rowData['locationGrouping']));
      }
      if(rowData['locationGroupingIds']){
        params = params.append('locationGrouping', this.toHttpParamValue(rowData['locationGroupingIds']));
      }
      if(rowData['timeOffset']){
        params = params.set('timeOffset', this.toHttpParamValue(rowData['timeOffset']));
      }
      if (rowData['idsOnly'] === true || rowData['idsOnly'] === 'true') {
        params = params.set('idsOnly', 'true');
      }

    return this.http.get(environment.apiUrl + 'fetch/discrepancies', { params });
  }


  /**
   * Fetch just the _id list for the current filter without transferring full
   * variance documents. Used by the "Select All across pages" print flow so we
   * can build a print token payload without dragging every projected field down
   * from the server.
   */
  getActivityDiscrepancyIds(filter: any, limit = 2000)
  {
    const rowData = { ...(filter || {}), idsOnly: true };
    return this.getActivityDiscrepancyData(0, rowData, limit);
  }

  /**
   * POST a list of variance _ids to the backend and receive back an opaque
   * token that identifies the cached list. The Variance Print handler exchanges
   * the token for the ids when the print window opens. This keeps the print
   * URL small even when Select-All spans many pages.
   */
  requestVariancePrintToken(ids: string[])
  {
    return this.http.post<{ token: string }>(environment.apiUrl + 'variancePrinting/token', { ids });
  }


  getCompiledData(maapkey: any, uniqueKey2: any, facilityId = null)
  {
    const params = {};
    (params as any)["maapKey"] = maapkey;
    (params as any)["uniqueKey2"] = uniqueKey2;
    if(facilityId)
    (params as any)["facilityId"]  = facilityId;
    return this.http.get(environment.apiUrl+'fetch/variances',{params:params});
  }

  getEhrData(maapkey: any, uniqueKey2: any, env: any, mrn: any)
  {
    const params = {}
    const version = environment.version
    if (version >= 4.1){
      (params as any)["RecordType"] = "EHR";
      (params as any)["uniqueKey2"] = uniqueKey2;
    }
    else{
      (params as any)["maapKey"] = maapkey;
      (params as any)["RecordType"] = "EHR";
      (params as any)["uniqueKey2"] = uniqueKey2;
      // if(facilityId)
      // params["facilityId"]  = facilityId;
      (params as any)['env'] = env;
      (params as any)['mrn'] = mrn;
    };
      (params as any)['$sortField'] = 'varDate';
      (params as any)['$sortOrder'] = 1;

    return this.http.get(environment.apiUrl+'fetch/adc_ehr',{params:params});
  }

  getAdcData(maapkey: any, uniqueKey2: any, env: any, mrn: any)
  {
    const params = {}
    const version = environment.version
    if (version >= 4.1){
      (params as any)["RecordType"] = "ADC";
      (params as any)["uniqueKey2"] = uniqueKey2;
    }
    else{
      (params as any)["maapKey"] = maapkey;
      (params as any)["RecordType"] = "ADC";
      (params as any)["uniqueKey2"] = uniqueKey2;
      (params as any)['env'] = env;
      (params as any)['mrn'] = mrn;
    };
      (params as any)['$sortField'] = 'varDate';
      (params as any)['$sortOrder'] = 1;
    return this.http.get(environment.apiUrl+'fetch/adc_ehr',{params:params});
  }

  getCompiledPagedData(skip: any)
  {
   return this.http.get(environment.apiUrl+'fetch/variances?$skip='+skip+'&$limit=10')
  }

  getNormalizedAdcEhrPagedData(skip: any, filter: any, limit: number = this.DEFAULT_PAGE_SIZE)
  {
    filter = this.normalizeAdcEhrDateFilter(filter);
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'fetch/adc_ehr?$skip='+skip+'&$limit='+limit+'&'+filterString);
  }

  getEhrPagedData(skip: any, filter: any, limit: number = this.DEFAULT_PAGE_SIZE)
  {
    filter = this.normalizeAdcEhrDateFilter(filter);
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    if(filter['RecordType'] != null){
      delete filter.RecordType;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'fetch/adc_ehr?RecordType=EHR&$skip='+skip+'&$limit='+limit+'&'+filterString);
  }

  getAdcPagedData(skip: any, filter: any, limit: number = this.DEFAULT_PAGE_SIZE)
  {
    filter = this.normalizeAdcEhrDateFilter(filter);
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    if(filter['RecordType'] != null){
      delete filter.RecordType;
    }
    
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'fetch/adc_ehr?RecordType=ADC&$skip='+skip+'&$limit='+limit+'&'+filterString)
  }

  private normalizeAdcEhrDateFilter(filter: any): any {
    return toStartEndFilterDateRange(cloneFilterState(filter || {}));
  }

  requestToken(data: any){
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    return this.http.get(environment.apiUrl+"request/token",{params:data,headers:headers,responseType: 'text'});
  }

  fetchEhrAdcFilterOptions(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'variance/filter/options?$'+filterString);
  }

  fetchAddTransactionFilterOptions(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'addTransaction/information?$'+filterString);
  }

  // MV2-361 / MV2-366
  fetchAdcFilterOptions(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'variance/adc/filter/options?$'+filterString);
  }

  fetchDiscrepancyFilterOptions(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    filter.analyticsRequest = "false";
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'filter/options?$'+filterString);
  }

  getDiscrepancyPagedData(skip: any, limit: number, filter: any){
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter));
   return this.http.get(environment.apiUrl+'discrepancies?$skip='+skip+'&$limit'+limit+'&'+filterString)
  }

  getLinkTransactionOption(skip: any, limit: any, filter: any){
    // if(filter['regionId'] == 'All' || !(filter['regionId'])){
    //   delete filter.regionId;
    // }
    // if(filter['campusId'] == 'All' || !(filter['campusId'])){
    //   delete filter.campusId;
    // }
    // if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
    //   delete filter.facilityId;
    // }
    // if(filter['serviceGroup'] == 'All'){
    //   delete filter.serviceGroup;
    // }
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
   return this.http.get(environment.apiUrl+'linkTransaction/options?$skip='+skip+'&$limit=10&'+filterString)
  }

  tryClearWhitespaceFromGlobalSearch(params: any)
  {
    if(params.globalSearch)
    {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  sanitizeFilterValue(value: any): any {
    if (Array.isArray(value)) {
      return value.map((item: any) => this.sanitizeFilterValue(item)).join(',');
    }

    if (value === null || value === undefined) {
      return value;
    }

    return value.toString().replace(/&/g, '[[AND]]');
  }

  private toHttpParamValue(value: unknown): string {
    const sanitizedValue = this.sanitizeFilterValue(value);
    return String(sanitizedValue);
  }

  generateQueryStringFromObject(params: any){
    params = cloneFilterState(params || {});
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params).map(key => key + '=' + this.sanitizeFilterValue(params[key])).join('&');
  }

  searchAutoComplete(field: any, text: any, filter: any = null) {
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(
      `${environment.apiUrl}autocomplete/search?field=${field}&text=${text}&${filterString}`
    );
  }

  submitLinkRecords(ids: any){
    return this.http.post(environment.apiUrl+'link/selected/records',{ids:ids})
  }
  addRecords(record: any){
    return this.http.post(environment.apiUrl+'add/record',{record: record})
  }
  linkRecords(record: any){
    return this.http.post(environment.apiUrl+'link/record',{record: record})
  }
  submitUnLinkRecords(ids: any, mainid: any){
    return this.http.post(environment.apiUrl+'delete/record/links',{ids:ids, mainRecordId:mainid})
  }
  deleteRecords(id: any){   
    return this.http.delete(environment.apiUrl+'delete/record/'+id)
  }
  getAdminInfo(data: any){   
    const filter = this.generateQueryStringFromObject(data);
    return this.http.get(environment.apiUrl+"get/admin/info?" + filter)
  }
  getPatientInfo(data: any){
    const filter = this.generateQueryStringFromObject(data);
    return this.http.get(environment.apiUrl+"get/patient/info?" + filter)
  }
}
